import { AppUtils } from '../../utils/index';

export class VesDamageKostenbelegModel {

	private waehrungBezeichnung: string;
	private waehrungKuerzel: string;
	private betrag: number;

	set WaehrungBezeichnung(value: string) {
		this.waehrungBezeichnung = value;
	}

	get WaehrungBezeichnung(): string {
		return this.waehrungBezeichnung;
	}
	set WaehrungKuerzel(value: string) {
		this.waehrungKuerzel = value;
	}

	get WaehrungKuerzel(): string {
		return this.waehrungKuerzel;
	}
	set Betrag(value: number) {
		this.betrag = value;
	}

	get Betrag(): number {
		return this.betrag;
	}

	/**
 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
 */
	public static createFromObject(dataObject: { [key: string]: any }): VesDamageKostenbelegModel {
		return AppUtils.Helper.createFromMap(dataObject, VesDamageKostenbelegModel);
	}
}
